import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IsExternalPipe } from '../../pipes/link-parser/is-external.pipe';
import { LinkParsePipe } from '../../pipes/link-parser/link-parser.pipe';

@Component({
	selector: 'valk-core-smart-link',
	standalone: true,
	imports: [RouterModule, IsExternalPipe, LinkParsePipe, CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<ng-template #contentTpl><ng-content /></ng-template>

		@let href = url();

		@if (!(href | isExternal)) {
			<a
				[attr.data-test-id]="testId() ?? null"
				[ngClass]="className()"
				[routerLink]="[href | linkparse]"
			>
				<ng-container [ngTemplateOutlet]="contentTpl" />
			</a>
		} @else {
			<a
				[attr.data-test-id]="testId() ?? null"
				[attr.rel]="rel() ?? 'noopener noreferrer'"
				[attr.target]="target() ?? null"
				[href]="href"
				[ngClass]="className()"
			>
				<ng-container [ngTemplateOutlet]="contentTpl" />
			</a>
		}
	`,
})
export class SmartLinkComponent {
	readonly url = input.required<string>();
	readonly className = input<string | undefined>(undefined);
	readonly testId = input<string | undefined>(undefined);

	readonly target = input<
		'_self' | '_blank' | '_parent' | '_top' | undefined
	>(undefined);
	readonly rel = input<string | undefined>(undefined);
}
